import React, { useRef, useState } from "react";
import {
  Button,
  Col,
  Row,
  Table,
  Alert,
  Modal,
  Descriptions,
  Input,
  Space,
} from "antd";
import {
  SearchOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";

export default function CModal({ visible, onCancel, onClose, dataModal }) {
  const handleOnClose = () => {
    onClose();
  };

  const handleOnCancel = () => {
    onCancel();

    return true;
  };

  //Store
  const [tbStoreSearchText, setTbStoreSearchText] = useState("");
  const [tbStoreSearchedColumn, setTbStoreSearchedColumn] = useState("");
  const tbStoreSearchInput = useRef(null);

  const tbDetailGetColumnSearchProps = (dataIndex) => ({
    // eslint-disable-next-line react/display-name
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={tbStoreSearchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            tbStoreHandleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              tbStoreHandleSearch(selectedKeys, confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => tbStoreHandleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setTbStoreSearchText(selectedKeys[0]);
              setTbStoreSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    // eslint-disable-next-line react/display-name
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    render: (text) =>
      tbStoreSearchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[tbStoreSearchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const tbStoreHandleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setTbStoreSearchText(selectedKeys[0]);
    setTbStoreSearchedColumn(dataIndex);
  };

  const tbStoreHandleReset = (clearFilters) => {
    clearFilters();
    setTbStoreSearchText("");
  };

  const columnAdjustDetail = [
    {
      title: "Supplier Barcode",
      dataIndex: "supplierBarcode",
      sorter: (a, b) => a.supplierBarcode.localeCompare(b.supplierBarcode),
      ...tbDetailGetColumnSearchProps("supplierBarcode"),
    },
    {
      title: "QTY",
      dataIndex: "qty",
      sorter: (a, b) => a.qty - b.qty,
      ...tbDetailGetColumnSearchProps("qty"),
    }
  ];

  return (
    <>
      <Modal
        width="90%"
        centered
        title="Stock Adjustment Detail"
        visible={visible}
        onCancel={handleOnCancel}
        footer={[
          <Button
            key="close"
            onClick={handleOnClose}
            icon={<CloseCircleOutlined />}
          >
            Close
          </Button>,
        ]}
      >
        <Row>
          <Col span={24}>
            <Descriptions
              bordered
              size="middle"
            >
              <Descriptions.Item label="Draft Number">
                {dataModal?.draftNumber}
              </Descriptions.Item>
              <Descriptions.Item label="Adjust Number">
                {dataModal?.adjustmentNumber}
              </Descriptions.Item>
              <Descriptions.Item label="Store">
                {dataModal?.store}
              </Descriptions.Item>
              <Descriptions.Item label="Status">
                {dataModal?.status}
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
        <br />
        <Row>
        <Col span={24} style={{ backgroundColor: "#DDF7F9", padding: 10 }}>
            <h3>Brand</h3>
            <Table
              loading={false}
              size="small"
              columns={columnAdjustDetail}
              dataSource={dataModal?.details}
              // pagination={{ pageSize: 5 }}
              pagination={false}
              scroll={{ y: 200 }}
              bordered
            />
            <Alert
              message={`Total data: ${dataModal?.details?.length} row(s)`}
              type="info"
              showIcon
            />
          </Col>
        </Row>
      </Modal>
    </>
  );
}
